// src/services/activityService.js
import axios from 'axios';
import api from './api';



export const getActivities = async () => {
  try {
    const response = await api.get(`/activities`);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch activities');
  }
};

export const getUserActivities = async (userId) => {
  try {
    const response = await api.get(`/user-activities/user/${userId}`);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch user activities');
  }
};

export const completeActivity = async (userId, activityId) => {
  try {
    const response = await api.patch(
      `/user-activities/user/${userId}/activity/${activityId}/complete`
    );
    return response.data;
  } catch (error) {
    throw new Error('Failed to complete activity');
  }
};


export const assignToAll = async (activityId) => {
  try {
    const response = await api.post(`/user-activities/activity/${activityId}/assign-to-all`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw new Error('Failed to fetch user activities');
  }
};